module.exports = __webpack_public_path__ + "static/media/qrcode.c507ad27.png";